<template>
  <div @click="extractsToggle(name, $event)" class="nav-item">
    <router-link
      :to="url"
      class="nav-link d-flex flex-column justify-content-center"
    >
      <div v-if="icon" class="icon" :class="iconClass" />
      <span class="text mt-1">{{ name }}
        <span v-if="expandIcon" class="expand-icon"><i /></span>
      </span>
    </router-link>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  ACTION_SET_SIDE_BAR_QUICK_ACTION,
  GETTER_SIDE_BAR_QUICK_ACTION
} from "../store/modules/common/constants";

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    expandIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconClass: "icon-" + this.icon
    };
  },
  methods: {
    extractsToggle(name, e) {
      if (name !== "Extracts") {
        document.body.classList.remove("sidebar-quick-action");
        this.setExtractToggle(false);
        return;
      }
      this.setExtractToggle(!this.getExtractToggle);
      document.body.classList.toggle("sidebar-quick-action");
      // do not use toggle here because of tag element clicking
      if (this.getExtractToggle) {
        e.target.classList.add("active");
        e.target.parentElement.classList.add("active");
      } else {
        e.target.classList.remove("active");
        e.target.parentElement.classList.remove("active");
      }
    },
    ...mapActions({
      setExtractToggle: ACTION_SET_SIDE_BAR_QUICK_ACTION
    })
  },
  computed: {
    ...mapGetters({
      getExtractToggle: GETTER_SIDE_BAR_QUICK_ACTION
    })
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/_core-variables";

div.nav-item {
  position: relative;
  .text{
    position: relative;
  }
  &[aria-expanded$="true"] .expand-icon {
    color: $aduro-primary-color;
    position: absolute;
    top: 7px;
    right: -15px;
    i:before {
      display: block;
      height: 12px;
      width: 12px;
      content: "";
      background: url("../assets/icons/icon-angle-right-red.svg") no-repeat;
      transform: rotate(90deg);
    }
  }
  &.collapsed a {
    .expand-icon {
      position: absolute;
      top: 15px;
      right: -15px;
      margin-top: -8px;
      color: $aduro-primary-color;
      i:before {
        display: block;
        height: 12px;
        width: 12px;
        content: "";
        background: url("../assets/icons/icon-angle-right-white.svg") no-repeat;
        transform: rotate(90deg);
      }
    }
    &.active,
    &:hover {
      .expand-icon {
        i:before {
          background: url("../assets/icons/icon-angle-right-red.svg") no-repeat;
          transform: rotate(90deg);
        }
      }
    }
  }
}

.fa-stack[data-count]:after {
  content: attr(data-count);
  font-size: 9px;
  line-height: 0.75em;
  color: $bg-grey;
  text-align: center; // font-weight: bold;
  top: 5px;
  position: absolute;
}

.fa-stack::after {
  align-content: center;
}

.nav-font-size-big {
  font-size: 12px;
}

.nav-font-size-small {
  font-size: 10px;
}

.sidebar .nav .nav-item .nav-link {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

a.nav-link {
  [class*=" icon-"] {
    font-size: 26px;
    line-height: 26px;
  }
  .icon {
    width: 32px;
    height: 32px;
  }
  .icon-home {
    background: url("../assets/icons/nav/home.svg") no-repeat;
  }
  .icon-program {
    background: url("../assets/icons/nav/manage.svg") no-repeat;
  }
  .icon-clients {
    background: url("../assets/icons/nav/group.svg") no-repeat;
  }
  .icon-user {
    background: url("../assets/icons/nav/profile.svg") no-repeat;
  }
  .icon-eligible_population {
    background: url("../assets/icons/nav/eligible-population.svg") no-repeat;
  }
  .icon-data_feeds {
    background: url("../assets/icons/nav/graph.svg") no-repeat;
  }
  .icon-email_template {
    background: url("../assets/icons/nav/mail.svg") no-repeat;
  }
  .icon-logs {
    background: url("../assets/icons/nav/copy.svg") no-repeat;
  }
  .icon-security {
    background: url("../assets/icons/nav/security.svg") no-repeat;
  }
  .icon-dashboard {
    width: 34px;
    height: 27px;
    background: url("../assets/icons/icon-dashboard-white.svg") no-repeat;
  }
  .icon-extracts {
    width: 34px;
    height: 37px;
    background: url("../assets/icons/icon-extracts-white.svg") no-repeat;
  }

  .icon-faq {
    width: 31px;
    height: 30px;
    background: url("../assets/icons/icon-faq-white.svg") no-repeat;
  }

  .icon-reports {
    width: 33px;
    height: 19px;
    background: url("../assets/icons/icon-reports-white.svg") no-repeat;
  }

  .icon-testupload {
    width: 35px;
    height: 41px;
    background: url("../assets/icons/icon-incentive.svg") no-repeat;
  }

  &.active,
  &.active:hover,
  &:hover {
    .icon-home {
      background: url("../assets/icons/nav/home-red.svg") no-repeat;
    }
    .icon-program {
      background: url("../assets/icons/nav/manage-red.svg") no-repeat;
    }
    .icon-clients {
      background: url("../assets/icons/nav/group-red.svg") no-repeat;
    }
    .icon-user {
      background: url("../assets/icons/nav/profile-red.svg") no-repeat;
    }
    .icon-eligible_population {
      background: url("../assets/icons/nav/eligible-population-red.svg") no-repeat;
    }
    .icon-data_feeds {
      background: url("../assets/icons/nav/graph-red.svg") no-repeat;
    }
    .icon-email_template {
      background: url("../assets/icons/nav/mail-red.svg") no-repeat;
    }
    .icon-security {
      background: url("../assets/icons/nav/security-red.svg") no-repeat;
    }
    .icon-logs {
      background: url("../assets/icons/nav/copy-red.svg") no-repeat;
    }
    .icon-dashboard {
      background: url("../assets/icons/icon-dashboard-red.svg") no-repeat;
    }
    .icon-reports {
      background: url("../assets/icons/icon-reports-red.svg") no-repeat;
    }

    .icon-extracts {
      background: url("../assets/icons/icon-extracts-red.svg") no-repeat;
    }

    .icon-faq {
      background: url("../assets/icons/icon-faq-red.svg") no-repeat;
    }

    .icon-testupload {
      background: url("../assets/icons/icon-incentive-red.svg") no-repeat;
    }
  }

  &:disabled .icon-extracts {
    background: url("../assets/icons/icon-extracts-black.svg") no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarNavIcons.vue